import { makeBaseSvgIconProps } from 'components/icons/_utils/makeBaseSvgIconProps'

export const IconBatteryLow = () => {
  return (
    <svg {...makeBaseSvgIconProps('0 0 9 17')} fill="currentColor">
      <path
        d="M12.6667 4.66659C12.8556 4.66659 13.014 4.73047 13.1417 4.85825C13.2695 4.98603 13.3334 5.14436 13.3334 5.33325L13.3334 6.66659L14.6667 6.66659L14.6667 9.33325L13.3334 9.33325L13.3334 10.6666C13.3334 10.8555 13.2695 11.0138 13.1417 11.1416C13.014 11.2694 12.8556 11.3333 12.6667 11.3333L2.00008 11.3333C1.81119 11.3333 1.65286 11.2694 1.52508 11.1416C1.3973 11.0138 1.33342 10.8555 1.33342 10.6666L1.33342 5.33325C1.33342 5.14436 1.39731 4.98603 1.52508 4.85825C1.65286 4.73047 1.81119 4.66658 2.00008 4.66658L12.6667 4.66659ZM12.0001 5.99992L4.66675 5.99992L4.66675 9.99992L12.0001 9.99992L12.0001 5.99992Z"
        fill="currentColor"
      />
    </svg>
  )
}
